///include /assets/js/app/p/card-capture.js
class CardCaptureDatacash extends CardCaptureDriver {
    static get type() {
        return "datacash"
    }
    /**
     *
     * @param {?string} return_url
     * @param {boolean} [from_vue]
     */
    init(return_url = null, from_vue = true) {
        // No action needed currently
    }
    /**
     * @param {HTMLFormElement} pf
     */
    async initForm(pf) {
        // No action needed currently
    }
}
CardCaptureDriver.add(CardCaptureDatacash)